import { Account, Vendor } from ".";
import { ParseKeys } from "i18next";

// Mirrored in ev-server's VendorInputs.ts, which rejects anything else.
// `label` is the stored value; `labelKey` is what the user reads.
export const ORGANIZATION_TYPES = (
  [
    ["For-Profit Corporation", "organization_types.for_profit"],
    ["Not-For-Profit Corporation", "organization_types.not_for_profit"],
    ["Sole Proprietorship", "organization_types.sole_proprietorship"],
    ["Partnership", "organization_types.partnership"],
    ["Co-operative", "organization_types.co_operative"],
    ["Indigenous Business", "organization_types.indigenous"],
    ["Government / Public Institution", "organization_types.government"],
  ] as const
).map(([label, labelKey], index) => ({
  id: index + 1,
  label,
  labelKey: labelKey as ParseKeys<"account">,
}));

export const INITIAL_ACCOUNT: Account = {
  // emailForm
  email: "",
  password: "",
  googleAccessToken: null,
  authProvider: null,

  // nameForm
  firstName: "",
  lastName: "",
  userType: "user",

  // addressForm
  phoneNumber: "",
  address: "",
  latitude: null,
  longitude: null,
  placeId: null,

  // emailVerificationForm
  emailVerified: false,

  // profile / dashboard fields
  profilePhotoUrl: null,
  profilePhoto: null,
  jobTitle: null,

  onboardingCompleted: false,
  vendorId: null,
  accessLevel: null,
};

export const INITIAL_VENDOR: Vendor = {
  // businessInfo
  businessName: "",
  operatingAs: null,
  operatingAsSameAsLegal: true,
  mailingSameAsBusiness: true,
  mailingAddress: null,
  businessWebsite: null,

  // PrivacyContact
  organizationType: "",
  primaryContactFirstName: "",
  primaryContactLastName: "",
  primaryContactPosition: "",
  primaryContactEmail: "",
  primaryContactPhone: "",
  notificationEmail: null,
  primaryContactIsSignatory: true,
  signatoryFirstName: null,
  signatoryLastName: null,
  signatoryPosition: null,
  signatoryEmail: null,
  signatoryPhone: null,

  // businessRegistration
  businessNumber: "",
  proofOfInsurance: null,
  proofOfInsuranceURL: null,
  insuranceExpiryDate: "",
  businessLicense: null,
  businessLicenseURL: null,

  // signatureForm
  offeringEvInstallation: "",
  province: "",
  electricalLicense: null,
  electricalLicenseURL: null,
  electricalLicenseNumber: null,
  electricalLicenseExpiryDate: "",
  declarationAccepted: false,
  termsAccepted: false,

  // Extra for Dashboard
  brandLogo: null,
  brandLogoUrl: null,
  brandAbout: null,
  brandGoogleReview: null,
  publicEmail: null,
  publicPhone: null,
};
